export const API_HOST = window._env_ != null ? window._env_.API_HOST : "";
export const SOCKET_SERVER = window._env_ != null ? window._env_.SOCKET_SERVER : "";
export const APP_BLOB_ROOT = window._env_ != null ? window._env_.APP_BLOB_ROOT : "";

export const API_ROOT = API_HOST + "api/";
export const ROOT = API_HOST + "/";
export const SESSION_TOKEN = "token";
export const LOGIN = "User/Login";
export const COMMON_ERROR_MSG = "Something went wrong!";
export const RECORD_SAVED_MSG = "Record saved successfully";
export const RECORD_UPDATED_MSG = "Record updated successfully";
export const RECORD_DELETED_MSG = "Record deleted successfully";
export const OTP_SENT = "OTP sent successfully to your email!";
export const ERROR_SENDING_OTP = "Error sending OTP. Please try again.";
export const ERROR_INVALID_OTP = "Invalid OTP. Please try again.";
export const OTP_VERIFIED_SUCCESSFULLY = "OTP verified successfully!";
export const APPLICATION_SUBMIT_SUCCESSFULLY = "Application submitted successfully!";
export const SUBMISSION_FAILED = "Submission failed. Please try again.";
export const FILE_TYPE_VALIDATION = "Invalid file type.";
export const FILE_SIZE_VALIDATION = "File size must not exceed 10MB.";
export const IMAGE_TOOLTIP_TEXT = "Delete Image";
export const DELETE_IMAGE_CONFIRMATION_PLAIN_MESSAGE = "Are you sure, want to delete this image?";
export const ALL_FIELDS_REQUIRED_MSG = "Please enter required details";
//api list
export const Verify_Otp_Api = "";
export const Submit_Applicant_Details_Api = "";
export const Submit_Upload_Documents_Api = "";
export const SEND_VERIFY_EMAIL_OTP = "LevridgeOTP/SendVerifyEmailOTP";
export const CONFIRM_EMAIL_OTP = "LevridgeOTP/ConfirmEmailOTP";
export const CONFIRM_EMAIL_OTP_FOR_USER_ACCOUNT = "LevridgeOTP/VerifyEmailOTPForAccount";
export const GET_APPLICATION_LIST_BY_EMAIL = "Applicant/GetApplicationListByEmail";
export const UPDATE_APPLICANT_DATA = "Applicant/UpdateApplicantData";

export const ADD_OR_UPDATE_INCOME_SOURCE = "Applicant/AddOrUpdateIncomeSource";
export const GET_INCOME_SOURCE_BY_APPLICATION_ID = "Applicant/GetIncomeSourceByApplicationID";
export const ADD_OR_UPDATE_EXPENSES = "Applicant/AddOrUpdateExpenses";
export const GET_EXPENSES_BY_APPLICATION_ID = "Applicant/GetExpensesByApplicationID";

export const GET_ALL_DROPDOWN_DATA_BY_NAME = "LevridgeOTP/GetAllDropdownDataByName";
export const GET_APPLICANT_INFORMATION_BY_APPLICATION_ID = "Applicant/GetApplicantInformationByApplicationId";
export const ADD_OR_UPDATE_CASH_SHORT_TERM_INVESTMENTS = "Applicant/AddOrUpdateCashShortTermInvestments";
export const GET_CASH_SHORT_TERM_INVESTMENTS_BY_APPLICATIONID = "Applicant/GetCashShortTermInvestmentsByApplicationID";
export const DELETE_CASH_SHORT_TERM_INVESTMENTS_BY_CASH_ID = "Applicant/DeleteCashShortTermInvestmentsByCashID";
export const ADD_OR_UPDATE_STOCK_BOND_GOV_SECURITY = "Applicant/AddOrUpdateStockBondGovSecurity";
export const GET_STOCK_BOND_GOV_SECURITY_BY_APPLICATION_ID = "Applicant/GetStockBondGovSecurityByApplicationID";
export const DELETE_STOCK_BOND_GOV_SECURITY_BY_STOCK_ID = "Applicant/DeleteStockBondGovSecurityByStockID";
export const GET_ACCOUNT_NOTE_RECEIVABLE_BY_APPLICATION_ID = "Applicant/GetAccountNoteReceivableByApplicationID";
export const ADD_O_RUPDATE_ACCOUNT_NOTE_RECEIVABLE = "Applicant/AddOrUpdateAccountNoteReceivable";
export const DELETE_ACCOUNT_NOTE_RECEIVABLE_BY_ACCOUNT_ID = "Applicant/DeleteAccountNoteReceivableByAccountID";
export const ADD_OR_UPDATE_CASH_VALUE_LIFE_INSURANCE = "Applicant/AddOrUpdateCashValueLifeInsurance";
export const DELETE_CASH_VALUE_LIFE_INSURANCE_BY_CASHVALUE_ID = "Applicant/DeleteCashValueLifeInsuranceByCashValueID";
export const GET_CASH_VALUE_LIFE_INSURANCE_BY_APPLICATION_ID = "Applicant/GetCashValueLifeInsuranceByApplicationID";
export const UPDATE_APPLICANT_FINANCIAL_DATA = "Applicant/UpdateApplicantFinancialData";
export const GET_FINANCIAL_STATEMENT_DATA = "Applicant/GetFinancialStatementData";

export const UPLOAD_PHOTO_IMAGE = "UploadImages/UploadPhotoImage";
export const UPLOAD_PDF_OR_DOC_FILE = "UploadImages/UploadPdfOrDocFile";
export const DELETE_DOCUMENT_DATA_BY_APPLICATION_ID = "Applicant/DeleteDocumentDataByApplicationId";
export const DELETE_DOCUMENT_BY_DOCUMENT_ID = "Applicant/DeleteDocumentByDocumentId";


export const ADD_OR_UPDATE_OWN_PERSONAL_RESIDENCE = "Applicant/AddOrUpdateOwnPersonalResidence";
export const GET_OWN_PERSONAL_RESIDENCE_BY_APPLICATION_ID = "Applicant/GetOwnPersonalResidenceByApplicationID";
export const DELETE_OWN_PERSONAL_RESIDENCE_BY_OWN_ID = "Applicant/DeleteOwnPersonalResidenceByOwnID";
export const ADD_OR_UPDATE_VESTED_INTREST_PENSION = "Applicant/AddOrUpdateVestedIntrestPension";
export const GET_VESTED_INTREST_PENSION_BY_APPLICATION_ID = "Applicant/GetVestedIntrestPensionByApplicationID";
export const DELETE_VESTED_INTREST_PENSION_BY_OWN_ID = "Applicant/DeleteVestedIntrestPensionByOwnID";
export const ADD_OR_UPDATE_UNLISTED_STOCKS = "Applicant/AddOrUpdateUnListedStocks";

export const ADDORUPDATEEQUITYINTERESTINBUSINESS = "Applicant/AddOrUpdateEquityInterestInBusiness";
export const GETEQUITYINTERESTINBUSINESSBYAPPLICATIONID = "Applicant/GetEquityInterestInBusinessByApplicationID";
export const DELETEEQUITYINTERESTINBUSINESSBYINCOMETYPEID = "Applicant/DeleteEquityInterestInBusinessByIncomeTypeID";

export const GET_UNLISTED_STOCKS_BY_APPLICATION_ID = "Applicant/GetUnListedStocksByApplicationID";
export const GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID = "Applicant/GetApplicationReviewCommentByApplicationId";
export const GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID = "Applicant/GetApplicantAssessmentInformationByApplicationId";
export const DELETE_UNLISTED_STOCKS_BY_UNLISTED_STOCK_ID = "Applicant/DeleteUnListedStocksByunlistedStockID";
export const ADD_OR_UPDATE_INVESTMENT = "Applicant/AddOrUpdateInvestment";
export const GET_INVESTMENT_BY_APPLICATION_ID = "Applicant/GetInvestmentByApplicationID";
export const DELETE_INVESTMENT_BY_INVESTMENT_ID = "Applicant/DeleteInvestmentByInvestmentID";
export const ADD_OR_UPDATE_GENERAL_AND_LIMITED_PARTENERSHIP = "Applicant/AddOrUpdateGeneralAndLimitedPartenership";
export const GET_GENERAL_AND_LIMITED_PARTENERSHIP_BY_APPLICATION_ID = "Applicant/GetGeneralAndLimitedPartenershipByApplicationID";
export const DELETE_GENERAL_AND_LIMITED_PARTENERSHIP_BY_INVESTMENT_ID = "Applicant/DeleteGeneralAndLimitedPartenershipByInvestmentID";
export const ADD_OR_UPDATE_NOTES_PAYABLE_BANK_SECURED = "Applicant/AddOrUpdateNotesPayableBankSecured";
export const GET_NOTES_PAYABLE_BANK_SECURED_BY_APPLICATION_ID = "Applicant/GetNotesPayableBankSecuredByApplicationID";
export const DELETE_NOTES_PAYABLE_BANK_SECURED_BY_NOTES_ID = "Applicant/DeleteNotesPayableBankSecuredByNotesID";
export const ADD_OR_UPDATENOTES_PAYABLE_BANK_UNSECURED = "Applicant/AddOrUpdateNotesPayableBankUnSecured";
export const GET_NOTES_PAYABLE_BANK_UNSECURED_BY_APPLICATION_ID = "Applicant/GetNotesPayableBankUnSecuredByApplicationID";
export const DELETE_NOTES_PAYABLE_BANK_UNSECURED_BY_NOTES_ID = "Applicant/DeleteNotesPayableBankUnSecuredByNotesID";
export const ADD_OR_UPDATE_NOTES_PAYABLE_OTHER = "Applicant/AddOrUpdateNotesPayableOther";
export const GET_NOTES_PAYABLE_OTHER_BY_APPLICATION_ID = "Applicant/GetNotesPayableOtherByApplicationID";
export const DELETE_NOTES_PAYABLE_OTHER_BY_NOTES_ID = "Applicant/DeleteNotesPayableOtherByNotesID";
export const ADD_OR_UPDATE_ACCOUNTS_PAYABLE = "Applicant/AddOrUpdateAccountsPayable";
export const GET_ACCOUNTS_PAYABLE_BY_APPLICATION_ID = "Applicant/GetAccountsPayableByApplicationID";
export const DELETE_ACCOUNTS_PAYABLE_BY_ACCOUNT_ID = "Applicant/DeleteAccountsPayableByAccountID";
export const ADD_OR_UPDATE_CREDIT_CARD_BALANCE = "Applicant/AddOrUpdateCreditCardBalance";
export const GET_CREDIT_CARD_BALANCE_BY_APPLICATION_ID = "Applicant/GetCreditCardBalanceByApplicationID";
export const DELETE_CREDIT_CARD_BALANCE_BY_CREDIT_ID = "Applicant/DeleteCreditCardBalanceByCreditID";
export const ADD_OR_UPDATE_MORTGAGE_DUE_WITHIN = "Applicant/AddOrUpdateMortgageDueWithin";
export const GET_MORTGAGE_DUE_WITHIN_BY_APPLICATION_ID = "Applicant/GetMortgageDueWithinByApplicationID";
export const DELETE_APPLICATION_BY_APPLICATION_ID = "Applicant/DeleteApplicantionByApplicationId";
export const SUBMIT_APPLICATION_BY_APPLICATION_ID = "Applicant/UpdateApplicantStatus";
export const DELETE_MORTGAGE_DUE_WITHIN_BY_ID = "Applicant/DeleteMortgageDueWithinByID";
export const ADD_OR_UPDATE_MORTGAGE_DUE_BEYOND = "Applicant/AddOrUpdateMortgageDueBeyond";
export const GET_MORTGAGE_DUE_BEYOND_BY_APPLICATION_ID = "Applicant/GetMortgageDueBeyondByApplicationID";
export const DELETE_MORTGAGE_DUE_BEYOND_BY_ID = "Applicant/DeleteMortgageDueBeyondByID";
export const GET_ALL_QUESTIONS = "Applicant/GetAllQuestions";
export const ADD_OR_UPDATE_QUESTIONS = "Applicant/AddOrUpdateQuestions";
export const GET_QUESTIONS_BY_APPLICATION_ID = "Applicant/GetQuestionsByApplicationID";
export const GET_SPONSER_DATA_BY_APPLICANT_EMAIL = "Sponser/GetSponserDataByApplicantEmail";
export const GET_APPLICATION_STATUS_BY_APPLICATION_ID = "Applicant/GetApplicationAllStatusByApplicationId";
export const GET_APPLICATION_STATUS_BY_APPLICATION_ID_AND_DOB = "Applicant/GetApplicationStatusByApplicationIdAndDOB";
export const USER_LOGIN = "Applicant/UserLogin";
export const FORGOT_USER_PASSWORD = "Applicant/ForgotUserPassword";
export const CHANGE_USER_PASSWORD = "Applicant/ChangeUserPassword";
export const FORGOT_PASSWORD_SEND_EMAIL_OTP = "LevridgeOTP/SendForgetPasswordOTPEmail";
export const GET_BANK_ADMIN_LIST_BY_EMAIL = "Applicant/GetBankAdminListByEmail";
export const GET_APPLICANTS_BY_EMAIL_AND_BANK_ADMIN = "Applicant/GetApplicantsByEmailAndBankAdmin";
export const GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID_AND_SECTION = "Applicant/GetApplicationReviewCommentByApplicationIdAndSection";
// Sponser API
export const ADD_UPDATE_SPONSER = "Sponser/AddOrUpdateSponser";
export const GET_SPONSER_DATA_BY_ID = "Sponser/GetSponserDataById";
export const GET_SPONSER_DATA_BY_BANKER_EMAIL_ID = "Sponser/GetSponserDataByApplicantEmail";
export const DELETE_SPONSER_BY_ID = "Sponser/DeleteSponser";
export const RESEND_EMAIL_WITH_LINK_AND_PASS = "Sponser/ReSendEmailWithLinkAndPasscode";
export const GET_SPONSER_LIST_BY_BANKER_ID = "Banker/GetSponserListByBankerId";
export const DELETE_SPONSER_APPLICANT_BY_ID = "Sponser/DeleteSponserApplicantByID";
export const GET_APPLICATION_LIST_BY_SPONSER_ID = "Applicant/GetApplicationListBySponserId";

// Banker API 
export const SEND_Banker_VERIFY_EMAIL_OTP = "Banker/SendVerifyEmailOTP";
export const CONFIRM_BANKER_EMAIL_OTP = "Banker/ConfirmEmailOTP";
export const UPDATE_BANKER_DATA = "Banker/UpdateBankerData";
export const BANKER_LOGIN = "Banker/BankerLogin";
export const GET_BANKER_INFORMATION_BY_BANKER_ID = "Banker/GetBankerInformationByBankerId";
export const FORGOT_BANKER_PASSWORD = "Banker/ForgotBankerPassword";
export const GET_BANKER_DASHBOARD_SUMMARY_BY_BANKER_ID = "Banker/GetBankerDashboardSummaryByBankerId";
export const ADD_OR_UPDATE_BANKER_METRICS_DATA = "Banker/AddOrUpdateBankerMetricsData";
export const GET_BANKER_METRICS_BY_BANKER_ID = "Banker/GetBankerMetricsByBankerIDAndSponserId";
export const GET_BANKER_LOAN_APPLICATION_SUMMARY = "Banker/GetBankerLoanApplicationMonthlySummaryByBankerId";
export const GET_ALL_LOAN_APPLICATION_LIST_BY_BANKER_ID = "Banker/GetAllLoanApplicationListByBankerId";
export const GET_BANKER_REVISIT_APPLICATION_LIST_BY_BANKER_ID = "Banker/GetBankerRevistApplicationListByBankerId"
export const ADD_OR_UPDATE_RISK_FREE_LOAN_DATA = "Banker/AddOrUpdateRiskFreeLoanData";
export const GET_RISK_FREE_LOAN_BY_APPLICANT_ID = "Banker/GetRiskFreeLoanByApplicantId";
export const ADD_APPLICATION_REVIEW_COMMENT = "Applicant/AddApplicationReviewComment";
export const GET_APPLICATION_REVIEW_COMMENT_FOR_BANKER = "Applicant/GetApplicationReviewCommentForBanker";
export const CHANGE_BANKER_PASSWORD = "Banker/ChangeBankerPassword";
export const UPDATE_APPLICANT_STATUS = "Applicant/UpdateApplicantStatus";
export const RESEND_SPONSER_APPLICANT_EMAIL_OTP = "Sponser/UpdateSponserApplicant";
export const DELETE_SPONSER_APPLICANTS_DATA = "Sponser/DeleteSponserApplicationData";

//Loan Officer API
export const SEND_LOAN_OFFICER_VERIFY_EMAIL_OTP = "LoanOfficer/SendVerifyEmailOTP";
export const CONFIRM_LOAN_OFFICER_EMAIL_OTP = "LoanOfficer/ConfirmEmailOTP";
export const UPDATE_LOAN_OFFICER_DATA = "LoanOfficer/UpdateLoanOfficerData";
export const LOAN_OFFICER_LOGIN = "LoanOfficer/LoanOfficerLogin";
export const FORGOT_LOAN_OFFICER_PASSWORD = "LoanOfficer/ForgotLoanOfficerPassword";
export const GET_LOAN_OFFICER_INFORMATION_BY_LOAN_OFFICER_ID = "LoanOfficer/GetLoanOfficerInformationByLoanOfficerId";
export const GET_LOAN_OFFICER_DASHBOARD_SUMMARY = "LoanOfficer/GetLoanOfficerDashboardSummary";
export const GET_APPLICATION_REVIEW_COMMENT_FOR_LOAN_OFFICER = "Applicant/GetApplicationReviewCommentForLoanOfficer";
export const GET_REVIST_APPLICATION_LIST_BY_LOANOFFICER_ID = "LoanOfficer/GetRevistApplicationListByLoanOfficerId"
export const CHANGE_LOAN_OFFICER_PASSWORD = "LoanOfficer/ChangeLoanOfficerPassword";
export const GET_ALL_LOAN_APPLICATION_LIST_BY_LOAN_OFFICER_ID = "LoanOfficer/GetAllLoanApplicationListByLoanOfficerId";

//Bank Admin API
export const SEND_VERIFY_EMAILOTP = "BankAdmin/SendVerifyEmailOTP";
export const BANK_ADMIN_CONFIRM_EMAIL_OTP = "BankAdmin/ConfirmEmailOTP";
export const UPDATE_BANK_ADMIN_DATA = "BankAdmin/UpdateBankAdminData";
export const BANK_ADMIN_LOG_IN = "BankAdmin/BankAdminLogin";
export const FORGOT_BANK_ADMIN_PASSWORD = "BankAdmin/ForgotBankAdminPassword";
export const GET_ALL_ROLL_BY_PARAMETER = "BankAdmin/GetAllRollByParameter";
export const UPDATE_USER_MANAGEMENT_DATA = "UserManagement/UpdateUserManagementData";
export const GET_ALL_USER_LIST_BY_BANK_ADMIN_ID = "UserManagement/GetAllUserListByBankAdminId";
export const DELETE_USER_ID = "UserManagement/DeleteUserID";
export const GET_BANK_ADMIN_INFORMATION_BY_BANK_ADMIN_ID = "BankAdmin/GetBankAdminInformationByBankAdminId";
export const CHANGE_BANK_ADMIN_PASSWORD = "BankAdmin/ChangeBankAdminPassword";
export const RESEND_EMAIL_WITH_LINK_AND_PASSCODE = "UserManagement/ReSendEmailWithLinkAndPasscode";
export const GET_SPONSER_DROPDOWN_LIST_BY_BANKERID = "Banker/GetSponserDropdownListByBankerId";
export const GET_ADMINISTRATOR_COUNT = "Banker/GetAdministratorCount";


//Firm Admin
// export const GET_FIRM_ADMIN_DATA_BY_FIRM_ADMIN_ID = "Sponser/GetFirmAdminDataByFirmAdminId";

export const GET_FIRM_ADMIN_DATA_BY_SPONSER_ID = "Sponser/GetFirmAdminDataBySponserId";
// export const GET_FIRM_ADMIN_ADVANCE_REPAYMENT_DATA_BY_FIRM_ADMIN_ID = "Sponser/GetFirmAdminAdvanceRepaymentDataByFirmAdminId";

export const GET_FIRM_ADMIN_ADVANCE_REPAYMENT_DATA_BY_SPONSER_ID = "Sponser/GetFirmAdminAdvanceRepaymentDataBySponserId";

export const GET_SPONSER_LIST_BY_EMAIL_AND_BANKADMINID = "Sponser/GetSponserListByEmailabdBankAdminId";
export const GET_FIRM_ADMIN_DASHBOARD_BY_EMAIL_AND_BANK_ADMIN_ID = "Sponser/GetFirmAdminDashboardByEmailandBankAdminId";

export const GET_ALL_CAPITAL_PROVIDER_LIST = "LoanOfficer/GetAllLoanOfficerList";

// Consumer API's
export const CONSUMER_LOGIN = "Applicant/UserLogin";
export const SEND_VERIFY_CONSUMER_EMAIL_OTP = "LevridgeOTP/VerifyConsumerEmailSendOTP";
export const CONSUMER_VERIFY_EMAIL_OTP = "LevridgeOTP/ConfirmEmailOTP";
export const RESEND_CONSUMER_VERIFY_EMAIL_OTP = "LevridgeOTP/VerifyConsumerEmailSendOTP";
export const UPDATE_CONSUMER_LOGIN_DATA = "Applicant/UpdateApplicantData";
export const GET_CONSUMER_INFORMATION_BY_CONSUMER_ID = "Applicant/GetApplicantInformationByApplicationId";
export const CHANGE_CONSUMER_PASSWORD = "";
export const GET_CONSUMER_APPLICANTS_BY_EMAIL = "Applicant/GetApplicantsByEmailAndBankAdmin";
export const UPDATE_CONSUMER_DATA = "Applicant/UpdateApplicantData";
export const UPLOAD_PDF_OR_DOC = "UploadImages/UploadPdfOrDocFile";
export const CAPITAL_PROVIDER_ADDED_MSG = "Capital Provider added successfullly";
export const GET_CONSUMER_REPORT_BY_CONSUMER_ID = "Applicant/GetApplicantInformationByAppId";
export const CREATEPREPOPULATEDPDFFORPFS = "Applicant/CreatePrepopulatedPDFforPFS";

